export default __webpack_public_path__ + "static/media/createActionH2@3x.0d6fbe42.png";